import Modal from "antd/lib/modal/Modal";
import React from "react";
import ImageView from "../ImageView/ImageView";
 import StablePrime from "./StablePrime";
import TimeLinePopUp from "./TimelinePopUp";

const TableModal = ({
  stableUrl,
  stableType,
  setStableModalVisible,
  stableModalVisible,
  record,
  stableAuxData,
}) => {
  
  return (
    <>
      {stableType && stableType === "stable" ? (
        <Modal
          title="Stable"
          open={stableModalVisible}
          style={{ minWidth: "1200px" }}
          onOk={() => {}}
          onCancel={() => {
            setStableModalVisible(false);
          }}
          cancelButtonProps={{ hidden: true }}
          okButtonProps={{ hidden: true }}
        >
          <StablePrime
            url={stableUrl}
            data={{ ...record, ...stableAuxData }}
            identity="Table"
          />
        </Modal>
      ) : null}
      {stableType && stableType === "timeLine" ? (
        <TimeLinePopUp
          visible={stableModalVisible}
          setVisible={setStableModalVisible}
          rowData={{ ...record, ...stableAuxData }}
        />
      ) : null}

      {stableType && stableType === "image" ? (
        <>
          <Modal
            title="Image"
            open={stableModalVisible}
            onOk={() => {}}
            onCancel={() => setStableModalVisible(false)}
            cancelButtonProps={{ hidden: true }}
            okButtonProps={{ ghost: true }}
          >
            <ImageView
              _id={record["popUpImgid"]}
              height="100%"
              width="100%"
              spinSize={40}
            />
          </Modal>
        </>
      ) : null}
    </>
  );
};

export default TableModal;
